module.exports = __webpack_public_path__ + "static/media/bcsgQAScreen4.ec101328.jpg";